import { Component, OnInit } from '@angular/core';
import { ReleaseSettings } from '../../release/models/releaseSettings.interface';
import { AbstractBiditComponent } from '../../shared/controls/abstract.bidit.component';
import { ReleaseService } from '../../release/services/release.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { FileService } from '../../shared/services/file.service';

@Component({
  selector: 'app-release-notes',
  templateUrl: './release-notes.component.html',
  styleUrl: './release-notes.component.scss'
})
export class ReleaseNotesComponent extends AbstractBiditComponent implements OnInit {
  releaseHistory: ReleaseSettings[];
  latestRelease: ReleaseSettings;

  constructor(deviceDetectorService: DeviceDetectorService,
    private releaseService: ReleaseService, private fileService: FileService) {
    super(deviceDetectorService);
  }

  ngOnInit(): void {
    this.loadReleaseInfo();
  }

  loadReleaseInfo() {
    this.releaseService.getList()
      .subscribe({
        next: (data) => {
          this.releaseHistory = data;
          this.latestRelease = this.releaseHistory?.[0];
        },
        error: (error: string) => this.onError(error)
      });
  }

  downloadAttachment() {
    this.releaseService.getReleaseAttachment(this.latestRelease.releaseSettings_ID)
      .subscribe({
        next: (data) => {
          this.fileService.downloadFile(data, this.latestRelease.releaseSettings_FileName);
        }
      });
  }
}
